// Race definitions ported from Java Race.java
// Each race has unique stat dice rolls for str, speed, mana, health

export interface Race {
  id: number;
  name: string;
  str: string;      // dice roll like "3d6+3"
  speed: string;
  mana: string;
  health: string;
}

// OpenArena race set (default)
export const RACES_OPEN_ARENA: Race[] = [
  { id: 0, name: 'Demoni', str: '3d6+3', speed: '3d6+3', mana: '2d6', health: '2d6+12' },
  { id: 1, name: 'Kentauri', str: '3d6+4', speed: '3d6+2', mana: '2d6', health: '2d6+12' },
  { id: 2, name: 'Driadi', str: '2d6', speed: '2d6', mana: '4d6+6', health: '2d6+12' },
  { id: 3, name: 'Enkeli', str: '2d6', speed: '3d6', mana: '3d6+9', health: '2d6+9' },
  { id: 4, name: 'Gnolli', str: '4d6+8', speed: '2d6', mana: '1d6', health: '3d6+10' },
  { id: 5, name: 'Goblin', str: '2d6', speed: '4d6+6', mana: '2d6+4', health: '2d6+8' },
  { id: 6, name: 'Pimeäritari', str: '1d6', speed: '3d6+6', mana: '4d6+6', health: '2d6+6' },
  { id: 7, name: 'Nagavelho', str: '2d6', speed: '3d6+6', mana: '3d6+2', health: '2d6+10' },
  { id: 8, name: 'Hobitti', str: '1d6+2', speed: '4d6+4', mana: '2d6+6', health: '3d6+6' },
  { id: 9, name: 'Imp', str: '2d6', speed: '3d6+6', mana: '3d6+6', health: '2d6+6' },
  { id: 10, name: 'Haamu', str: '2d6', speed: '4d6+6', mana: '2d6', health: '2d6+12' },
  { id: 11, name: 'Haltiapappi', str: '3d6', speed: '1d6', mana: '3d6+6', health: '3d6+12' },
  { id: 12, name: 'Haltiaritari', str: '2d6+6', speed: '2d6', mana: '2d6', health: '4d6+12' },
  { id: 13, name: 'Harpyija', str: '4d6', speed: '1d6+4', mana: '2d6', health: '3d6+14' },
  { id: 14, name: 'Kivihirviö', str: '5d6+6', speed: '1d6', mana: '1d6', health: '4d6+12' },
  { id: 15, name: 'Kääpiö', str: '3d6+2', speed: '2d6', mana: '2d6', health: '3d6+16' },
  { id: 16, name: 'Zombiejätti', str: '3d6', speed: '1d6+6', mana: '3d6+4', health: '3d6+8' },
  { id: 17, name: 'Liskomies', str: '3d6', speed: '2d6', mana: '2d6+8', health: '3d6+10' },
  { id: 18, name: 'Minotauri', str: '4d6+10', speed: '1d6', mana: '2d6', health: '3d6+8' },
  { id: 19, name: 'Kyklooppi', str: '2d6+6', speed: '3d6', mana: '2d6+6', health: '3d6+6' },
  { id: 20, name: 'Muumio', str: '2d6+6', speed: '1d6', mana: '2d6+6', health: '5d6+6' },
  { id: 21, name: 'Merenneito', str: '2d6', speed: '2d6+2', mana: '4d6+4', health: '2d6+12' },
  { id: 22, name: 'Naga', str: '2d6+6', speed: '4d6', mana: '2d6', health: '2d6+12' },
  { id: 23, name: 'Noita', str: '2d6', speed: '2d6', mana: '4d6+6', health: '2d6+12' },
  { id: 24, name: 'Fauni', str: '5d6+6', speed: '1d6', mana: '1d6', health: '3d6+12' },
  { id: 25, name: 'Pyhäkentauri', str: '2d6', speed: '3d6', mana: '3d6+6', health: '2d6+12' },
  { id: 26, name: 'Peikko', str: '4d6+6', speed: '2d6', mana: '1d6', health: '3d6+12' },
  { id: 27, name: 'Ritari', str: '3d6+2', speed: '3d6+1', mana: '2d6+3', health: '2d6+12' },
  { id: 28, name: 'Pyhäritari', str: '2d6+6', speed: '3d6+4', mana: '2d6+2', health: '3d6+6' },
  { id: 29, name: 'Jätti', str: '2d6+4', speed: '2d6+4', mana: '2d6+4', health: '3d6+6' },
  { id: 30, name: 'Luuranko', str: '3d6+8', speed: '2d6', mana: '2d6', health: '3d6+10' },
  { id: 31, name: 'Tonttu', str: '1d6', speed: '6d6+8', mana: '2d6+2', health: '1d6+8' },
  { id: 32, name: 'Velho', str: '2d6', speed: '2d6', mana: '4d6+6', health: '2d6+12' },
  { id: 33, name: 'Vampyyri', str: '1d6', speed: '3d6+6', mana: '3d6+6', health: '3d6+6' },
  { id: 34, name: 'Örkkivelho', str: '4d6', speed: '2d6', mana: '1d6', health: '3d6+18' },
  { id: 35, name: 'Örkki', str: '2d6+4', speed: '3d6+4', mana: '3d6', health: '2d6+10' },
];

// Areena 5 race set (classic Finnish version)
export const RACES_AREENA_5: Race[] = [
  { id: 0, name: 'Amatsoni', str: '3d6+3', speed: '3d6+3', mana: '2d6', health: '2d6+12' },
  { id: 1, name: 'Barbaari', str: '3d6+4', speed: '3d6+2', mana: '2d6', health: '2d6+12' },
  { id: 2, name: 'Druidi', str: '2d6', speed: '2d6', mana: '4d6+6', health: '2d6+12' },
  { id: 3, name: 'Feenix', str: '2d6', speed: '3d6', mana: '3d6+9', health: '2d6+9' },
  { id: 4, name: 'Gnolli', str: '4d6+8', speed: '2d6', mana: '1d6', health: '3d6+10' },
  { id: 5, name: 'Goblin', str: '2d6', speed: '4d6+6', mana: '2d6+4', health: '2d6+8' },
  { id: 6, name: 'Goblinvelho', str: '1d6', speed: '3d6+6', mana: '4d6+6', health: '2d6+6' },
  { id: 7, name: 'Haltia', str: '2d6', speed: '3d6+6', mana: '3d6+2', health: '2d6+10' },
  { id: 8, name: 'Hobitti', str: '1d6+2', speed: '4d6+4', mana: '2d6+6', health: '3d6+6' },
  { id: 9, name: 'Imp', str: '2d6', speed: '3d6+6', mana: '3d6+6', health: '2d6+6' },
  { id: 10, name: 'Jänis', str: '2d6', speed: '4d6+6', mana: '2d6', health: '2d6+12' },
  { id: 11, name: 'Jäämies', str: '3d6', speed: '1d6', mana: '3d6+6', health: '3d6+12' },
  { id: 12, name: 'Kaamio', str: '2d6+6', speed: '2d6', mana: '2d6', health: '4d6+12' },
  { id: 13, name: 'Karhumies', str: '4d6', speed: '1d6+4', mana: '2d6', health: '3d6+14' },
  { id: 14, name: 'Kivihirviö', str: '5d6+6', speed: '1d6', mana: '1d6', health: '4d6+12' },
  { id: 15, name: 'Kääpiö', str: '3d6+2', speed: '2d6', mana: '2d6', health: '3d6+16' },
  { id: 16, name: 'Kääpiövelho', str: '3d6', speed: '1d6+6', mana: '3d6+4', health: '3d6+8' },
  { id: 17, name: 'Liskomies', str: '3d6', speed: '2d6', mana: '2d6+8', health: '3d6+10' },
  { id: 18, name: 'Minotauri', str: '4d6+10', speed: '1d6', mana: '2d6', health: '3d6+8' },
  { id: 19, name: 'Munkki', str: '2d6+6', speed: '3d6', mana: '2d6+6', health: '3d6+6' },
  { id: 20, name: 'Muumio', str: '2d6+6', speed: '1d6', mana: '2d6+6', health: '5d6+6' },
  { id: 21, name: 'Mystikko', str: '2d6', speed: '2d6+2', mana: '4d6+4', health: '2d6+12' },
  { id: 22, name: 'Ninja', str: '2d6+6', speed: '4d6', mana: '2d6', health: '2d6+12' },
  { id: 23, name: 'Noita', str: '2d6', speed: '2d6', mana: '4d6+6', health: '2d6+12' },
  { id: 24, name: 'Otus', str: '5d6+6', speed: '1d6', mana: '1d6', health: '3d6+12' },
  { id: 25, name: 'Parantajatar', str: '2d6', speed: '3d6', mana: '3d6+6', health: '2d6+12' },
  { id: 26, name: 'Peikko', str: '4d6+6', speed: '2d6', mana: '1d6', health: '3d6+12' },
  { id: 27, name: 'Ritari', str: '3d6+2', speed: '3d6+1', mana: '2d6+3', health: '2d6+12' },
  { id: 28, name: 'Rosvo', str: '2d6+6', speed: '3d6+4', mana: '2d6+2', health: '3d6+6' },
  { id: 29, name: 'Samooja', str: '2d6+4', speed: '2d6+4', mana: '2d6+4', health: '3d6+6' },
  { id: 30, name: 'Sumo', str: '3d6+8', speed: '2d6', mana: '2d6', health: '3d6+10' },
  { id: 31, name: 'Tonttu', str: '1d6', speed: '6d6+8', mana: '2d6+2', health: '1d6+8' },
  { id: 32, name: 'Velho', str: '2d6', speed: '2d6', mana: '4d6+6', health: '2d6+12' },
  { id: 33, name: 'Velhotar', str: '1d6', speed: '3d6+6', mana: '3d6+6', health: '3d6+6' },
  { id: 34, name: 'Zombie', str: '4d6', speed: '2d6', mana: '1d6', health: '3d6+18' },
  { id: 35, name: 'Örkki', str: '2d6+4', speed: '3d6+4', mana: '3d6', health: '2d6+10' },
];

// Use original Areena 5 race set
export const RACES = RACES_AREENA_5;

// Helper to get race by ID
export function getRaceById(id: number): Race | undefined {
  return RACES.find(race => race.id === id);
}

// Helper to get race by name
export function getRaceByName(name: string): Race | undefined {
  return RACES.find(race => race.name === name);
}

// Get a random race
export function getRandomRace(): Race {
  return RACES[Math.floor(Math.random() * RACES.length)];
}
